// react-native-blob-util's fs errors quote the full local path, which carries both a
// per-copy UUID directory and the member's own filename:
//
//   failed to stat path `/data/user/0/com.nutrisense/files/0d71dfa2-.../May 20%2C 2026.pdf`
//
// Bugsnag groups on the message, so every occurrence lands in its own group and a
// recurring upload failure never accumulates enough events in one place to be noticed —
// which is how a filename bug that blocked uploads went unspotted for ten months.
// Collapsing the volatile parts groups the same failure together; the real path is
// still reported, as metadata on the event.

const PATH_IN_BACKTICKS = /`[^`]*`/g
const FILE_URI = /file:\/\/\S*/g

export const normalizeUploadErrorMessage = (message?: string) =>
  (message ?? 'Unknown direct upload error')
    .replace(PATH_IN_BACKTICKS, '`<path>`')
    .replace(FILE_URI, '<path>')
